import { render, staticRenderFns } from "./DeleteTemplateBtn.vue?vue&type=template&id=7680604d&"
import script from "./DeleteTemplateBtn.vue?vue&type=script&lang=ts&"
export * from "./DeleteTemplateBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports